import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  
  connect() {
    
    // タッチイベントの設定
    this.setupTouchEvents()
    
    // マウスホバーイベントの設定
    this.setupMouseEvents()
  }
  
  disconnect() {
    // イベントリスナーのクリーンアップ
    if (this.containerTarget) {
      this.containerTarget.removeEventListener('touchstart', this.handleTouchStart)
      this.containerTarget.removeEventListener('touchmove', this.handleTouchMove)
      this.containerTarget.removeEventListener('touchend', this.handleTouchEnd)
      this.containerTarget.removeEventListener('mousedown', this.handleMouseDown)
      this.containerTarget.removeEventListener('mousemove', this.handleMouseMove)
      this.containerTarget.removeEventListener('mouseup', this.handleMouseUp)
      this.containerTarget.removeEventListener('mouseleave', this.handleMouseLeave)
    }
    document.removeEventListener('mouseup', this.handleMouseUp)
  }
  
  setupTouchEvents() {
    const container = this.containerTarget
    
    let startX = 0
    let scrollLeft = 0
    let isDown = false
    
    this.handleTouchStart = (e) => {
      isDown = true
      startX = e.touches[0].pageX - container.offsetLeft
      scrollLeft = container.scrollLeft
    }
    
    this.handleTouchMove = (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.touches[0].pageX - container.offsetLeft
      const walk = (x - startX) * 2 // スクロール速度の調整
      container.scrollLeft = scrollLeft - walk
    }
    
    this.handleTouchEnd = () => {
      isDown = false
    }
    
    container.addEventListener('touchstart', this.handleTouchStart, { passive: false })
    container.addEventListener('touchmove', this.handleTouchMove, { passive: false })
    container.addEventListener('touchend', this.handleTouchEnd)
  }
  
  setupMouseEvents() {
    const container = this.containerTarget
    
    let startX = 0
    let scrollLeft = 0
    let isDown = false
    
    // マウスドラッグでのスクロールのみ
    this.handleMouseDown = (e) => {
      isDown = true
      startX = e.pageX - container.offsetLeft
      scrollLeft = container.scrollLeft
      container.style.cursor = 'grabbing'
      container.style.userSelect = 'none'
    }
    
    this.handleMouseMove = (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - container.offsetLeft
      const walk = (x - startX) * 2
      container.scrollLeft = scrollLeft - walk
    }
    
    this.handleMouseUp = () => {
      isDown = false
      container.style.cursor = 'grab'
      container.style.userSelect = ''
    }
    
    this.handleMouseLeave = () => {
      isDown = false
      container.style.cursor = 'grab'
      container.style.userSelect = ''
    }
    
    container.addEventListener('mousedown', this.handleMouseDown)
    container.addEventListener('mousemove', this.handleMouseMove)
    container.addEventListener('mouseup', this.handleMouseUp)
    container.addEventListener('mouseleave', this.handleMouseLeave)
    
    // マウスがコンテナ外に出た時の処理
    document.addEventListener('mouseup', this.handleMouseUp)
  }

  scrollLeft() {
    const container = this.containerTarget
    
    const scrollAmount = 380 // カード1つ分のスクロール量（320px + 24px margin + 余裕）
    
    // scrollByが効かない場合のフォールバック
    if (container.scrollBy) {
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' })
    } else {
      container.scrollLeft -= scrollAmount
    }
    
    setTimeout(() => {
    }, 100)
  }

  scrollRight() {
    const container = this.containerTarget
    
    const scrollAmount = 380 // カード1つ分のスクロール量（320px + 24px margin + 余裕）
    
    // scrollByが効かない場合のフォールバック
    if (container.scrollBy) {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' })
    } else {
      container.scrollLeft += scrollAmount
    }
    
    setTimeout(() => {
    }, 100)
  }
}
